export const GET = 'get';
export const POST = 'post';
export const PUT = 'put';
export const STORE = 'store';
export const CREATE = 'create';
export const EDIT = 'edit';
export const DELETE = 'delete';
